(function () {
    const moreLinks = document.querySelectorAll(".more__link");

    for (const moreLink of moreLinks) {
        moreLink.addEventListener("click", (e) => {
            // Część przycisków to <a href="#"> (zgody w formularzach wpłaty). Bez tego
            // przeglądarka dopisuje "#" do adresu, a na pełnej stronie (nie w modalu)
            // przewija widok na samą górę. Na <span> wywołanie jest bez efektu.
            e.preventDefault();

            const moreLinkMore = moreLink.querySelector('.more__linkMore');
            const moreLinkLess = moreLink.querySelector('.more__linkLess');
            const target = document.getElementById(moreLink.getAttribute("data-target"));
            
            if (target.classList.contains("more__wrapper--active")) {
                target.style.height = "0px";
                target.classList.remove("more__wrapper--active");
                
                if (moreLinkMore) moreLinkMore.style = "display: flex";
                if (moreLinkLess) moreLinkLess.style = "display: none";
            } else {
                target.style.height = target.scrollHeight + "px";
                target.classList.add("more__wrapper--active");
                if (moreLinkMore) moreLinkMore.style = "display: none";
                if (moreLinkLess) moreLinkLess.style = "display: flex";
            }
        });

    }

})();